import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import NoMeetingsFoundIcon from '../../../assets/images/no-meetings-found-icon.png'
import './MeetingNotFound.scss'

export const MeetingNotFound: React.FC = () => {
  return (
    <Container className='d-flex flex-column align-items-center gap-2 align-self-stretch'>
      <Row className='p-0'>
        <div className='text-center mt-5'>
          <img alt='Meeting not found' src={NoMeetingsFoundIcon} className='meeting-not-found-icon' />
        </div>
      </Row>
      <Row>
        <Col className='mx-auto'>
          <div className='d-flex flex-column gap-2 justify-content-center align-items-center text-center mt-3'>
            <p className='zocks-text-gray-900 paragraph-large medium text-center mb-0'>Meeting not found</p>
            <p className='paragraph-small'>This meeting doesn’t exist or you don’t have access to it.</p>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
